export const censorRecipient = (text, size = 1, mark = '*') => {
  if (typeof text !== 'string') return text;
  if (text.length <= size) return text;
  return text.slice(0, size) + mark.repeat(text.length - size);
}

export const censorMobile = (text, size = 3, mark = '*') => {
  if (typeof text !== 'string') return text;
  // 電話隱碼：保留後三碼，前面用 * 代替
  if (text.length < size) return text;
  return mark.repeat(text.length - size) + text.slice(-size);
}

export const censorAddress = (text, size = 3, mark = '*') => {
  if (typeof text !== 'string') return text;
  // 地址隱碼：保留前 6 個字，其餘用 * 代替
  if (text.length <= size) return text;
  return text.slice(0, size) + mark.repeat(text.length - size);
}